import { RhCard, RhDivider, RhIcon } from "@rhythm-ui/react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import React, { useMemo } from "react";
import { twMerge } from "tailwind-merge";

import { JobType } from "@/types/job";

import formatExperienceRange from "@/helpers/formatExperienceRange";

dayjs.extend(relativeTime);

const JobCardMobileView = ({
  job,
  onJobCardClick,
  className,
}: {
  job: JobType;
  onJobCardClick: (candidateId: number) => void;
  className: string;
}) => {
  const createdAtDate = dayjs(job.created_ts);
  const postedAt = createdAtDate.fromNow();

  const len = job.is_applied ? job?.self_applied_candidates?.length : undefined;
  const AppliedAtDate =
    len && job.is_applied
      ? dayjs(job?.self_applied_candidates[len - 1]?.is_applied_on)
      : undefined;
  const AppliedAt = AppliedAtDate?.fromNow();

  return (
    <RhCard
      className={`card-hover relative mb-tsm overflow-visible rounded ${className}`}
      onClick={() => job.id && onJobCardClick(job.id)}
    >
      <div className="flex space-y-tnano px-tmini py-tnano">
        <div className="mr-tm2 flex h-[50px] w-[50px] items-center justify-between rounded-md border px-tnano">
          {job.company?.logo && (
            <img src={job.company?.logo} className="w-full" />
          )}
        </div>
        <div className="space-y-tpico">
          <div className="flex items-center gap-2">
            <h3 className="mb-[6px] text-base font-medium">{job.title}</h3>
            {job.status === "Hold" && (
              <span className="text-gray rounded-md bg-yellow-50 px-2 py-0.5 text-xs">
                Job On Hold
              </span>
            )}
          </div>
          {job.company?.name && (
            <p className="body-small text-light mb-tsm">{job.company?.name}</p>
          )}
        </div>
      </div>
      <JobPositionAndSkills job={job} className="px-tsm" />
      {/* experience */}
      <JobExpectation job={job} />
      <div className="">
        <RhDivider />
      </div>

      <div className="flex items-center justify-between px-tsm py-tnano">
        <div>
          {job.is_applied ? (
            <div className="rounded-full bg-green-500 px-2">
              <p className="body-small">{`Applied ${AppliedAt}`}</p>
            </div>
          ) : (
            <p className="text-hint body-small">{`Posted ${postedAt}`}</p>
          )}
        </div>
        <div>
          <div className="flex justify-end gap-tm2">
            {/* TODO: will need it again */}
            {/* <RhButton
              layout="outline"
              className={job.is_applied ? "" : "hidden"}
              onClick={(e) => {
                e.stopPropagation();
                setOpenJobApplicationStatusDrawer(job);
              }}
            >
              View timeline
            </RhButton> */}
            {/* {job.is_applied && (
              <RhButton layout="outline">Revoke application</RhButton>
            )} */}
          </div>
        </div>
      </div>
    </RhCard>
  );
};
export default JobCardMobileView;

export const JobPositionAndSkills = ({
  job,
  className,
}: {
  job: JobType;
  className?: string;
}) => {
  if (!job?.job_role && !job.primary_skills.length) return null;

  return (
    <div className={className ?? ""}>
      <p className="inline border-b border-dashed">{job?.job_role?.name}</p>
      <div className="mt-tnano flex flex-wrap items-center gap-tpico">
        {job.primary_skills?.map((item: any) => {
          return (
            <div
              key={item.id}
              className="rounded-[32px] border border-gray-300 px-tnano py-[1px] hover:bg-gray-100"
              data-testid="added-location"
            >
              <p className="body-small">{item?.name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const JobExpectation = ({
  job,
  className,
}: {
  job: JobType;
  className?: string;
}) => {
  const candidateLocationPreference = useMemo(
    () => "(" + job.location_new.map((city) => city.name).join(", ") + ")",

    [job.location_new],
  );

  return (
    <div
      className={twMerge("flex flex-wrap gap-tsm px-4 py-tsm", className ?? "")}
    >
      <div className="flex items-center gap-tnano">
        <RhIcon
          icon={"tabler:briefcase"}
          className="text-hint text-lg"
        ></RhIcon>
        <p className="body-small">
          {formatExperienceRange.number({
            min: job.min_exp,
            max: job.max_exp,
          })}
        </p>
      </div>
      <div className="flex items-center gap-tnano">
        <RhIcon icon={"tabler:map-pin"} className="text-hint text-lg"></RhIcon>

        <div className="flex gap-tpico">
          <p className="body-small">{job.work_preference_new?.join(", ")}</p>
          <p className="text-light body-small">
            {job.work_preference_new && job.location_new?.length > 0 && (
              <>{candidateLocationPreference}</>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};
